import React, { FC, useState } from 'react';

import { ResponsivenessConfig } from 'components/ResponsiveImg/StyledResponsiveImg';
import { getImageAlt } from 'helpers/seoHelper';
import { useUrlBuilder } from 'hooks/useUrlBuilder';
import { SearchResult } from 'models/search';

import { Image } from './Image';

const handleSmallImage = e => {
  if (e.target.height < 200) {
    const newStyles = `
    `;
    e.target.setAttribute('style', newStyles);
  }
};

const handleMouseLeave = ({ images, setCurrentImage }: { images?: string[]; setCurrentImage: (n: number) => void }) => {
  if (images && images.length > 0) {
    setCurrentImage(0);
  }
};

const handleMouseEnter = ({ images, setCurrentImage }: { images?: string[]; setCurrentImage: (n: number) => void }) => {
  if (images && images[1]) {
    setCurrentImage(1);
  }
};

export const ImageChangingOnHover: FC<{
  cart?: boolean;
  height?: string;
  imageContainerClassNames?: string[];
  images?: string[];
  left?: string;
  maxHeight?: string;
  maxWidth?: string;
  product: SearchResult;
  responsivenessConfig?: ResponsivenessConfig;
  shimmerBackground?: boolean;
  width?: string;
}> = props => {
  const { withCDN } = useUrlBuilder();
  const [currentImage, setCurrentImage] = useState(0);

  const {
    images,
    width,
    height,
    cart,
    product,
    responsivenessConfig,
    shimmerBackground,
    imageContainerClassNames,
    left,
    maxHeight,
    maxWidth,
  } = props;

  const unpackImage = ({ imageSrc, idx }: { idx: number; imageSrc: string }) => {
    return (
      <Image
        alt={product ? getImageAlt({ brandName: product.brand, model: product.model }) : null}
        data-cy="image-product"
        display={currentImage !== idx ? 'none' : 'inline'}
        height={height}
        left={left}
        maxHeight={maxHeight}
        maxWidth={maxWidth}
        onError={e => {
          (e.target as HTMLImageElement).src = withCDN('mkt/icon/no_image.png');
        }}
        onLoad={e => (cart ? undefined : handleSmallImage(e))}
        position="absolute"
        responsivenessConfig={responsivenessConfig}
        src={imageSrc}
        width={width}
      />
    );
  };

  return (
    <>
      <div
        className={`image-changing-on-hover ${imageContainerClassNames?.join(' ') || ''} ${
          shimmerBackground ? 'global-shimmer-animate' : ''
        }`}
        onMouseEnter={() => {
          handleMouseEnter({ images, setCurrentImage });
        }}
        onMouseLeave={() => {
          handleMouseLeave({ images, setCurrentImage });
        }}
      >
        {images.map((imageSrc, idx) => unpackImage({ idx, imageSrc }))}
      </div>

      <style jsx>{`
        .image-changing-on-hover {
          position: relative;
          ${height ? `height: ${height}` : ''};
          ${width ? `width: ${width}` : ''};
        }
      `}</style>
    </>
  );
};
